import controller from './doctor-list.controller';
import template from './doctor-list.html';


const doctorListComponent = {
	bindings: {
		doctorList: '<',
		language: '<'
	},
	controller,
	template,
};

export default doctorListComponent;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-list/doctor-list.component.js